// phamulaHandler 方程式数据解析

const types = [
	{
		type: 'typeHeader', // 头部
		many: false		// 是否是多obj结构
	},
	{
		type: 'typeFooter', // 尾部
		many: false
	},
	{
		type: 'typeTalk', // 客服聊天窗口(弹窗)
		many: false
	},
	{
		type: 'typeA',	// 轮播图
		many: false
	},
	{
		type: 'typeB',	// 二分左文右图
		many: false
	},
	{
		type: 'typeC',	// 二分左图右文
		many: false
	},
	{
		type: 'typeD',	// N分同主题文
		many: false
	},
	{
		type: 'typeE',	// 横幅文字说明
		many: false
	},
	{
		type: 'typeF',	// 横幅一排图片
		many: false
	},
	{
		type: 'typeG',	// 简版收email框
		many: false
	},
	{
		type: 'typeH',	// 音视频框
		many: false
	},
	{
		type: 'typeI',	// 预购买框
		many: false
	},
	{
		type: 'typeJ',	// 接受隐私条款(弹窗)
		many: false
	},
	{
		type: 'typeK',	// N分栏不同主题图文说明
		many: true
	},
	{
		type: 'typeL',	// 自动翻页N条评价
		many: true
	},
	{
		type: 'typeM',	// N分图文书签效果
		many: true
	},
	{
		type: 'typeN',	// 3D模型显示框
		many: false
	},
	{
		type: 'typeO',	// 常见问题
		many: false
	},
	{
		type: 'typeP',	// 下载文件
		many: false
	},
	{
		type: 'typeQ',	// 输入口令(弹窗)
		many: false
	},
	{
		type: 'typeR',	// markdown文本
		many: false
	}
];

// 数据类型
function dataType(data = null, type = '') {
    let _type = Object.prototype.toString.apply(data).slice(8, -1).toLowerCase();
    return type ? (type.indexOf(_type) > -1) : _type;
}

// 文件类型
function fileType(url = '', _type = '') {
    // url文件链接，type如果传了就判断相不相等，否则返回文件类型
    let __type = '';
    let suffix = '';
    try {
    	let temp = url.split('.');
    	suffix = temp[temp.length - 1];
    } catch (err) {
    	suffix = '';
    }
    const typeConfig = {
    	'txt': [ 'txt' ],
    	'pdf': [ 'pdf' ],
    	'ppt': [ 'ppt', 'pptx' ],
    	'word': [ 'doc', 'docx' ],
    	'excel': [ 'xls', 'xlsx' ],
    	'image': [ 'png', 'jpg', 'jpeg', 'bmp', 'gif' ],
    	'audio': [ 'wav', 'mp3', 'm4a', 'ogg', 'acc', 'webm' ],
    	'video': [
    			'avi', 'flv', 'mpg', 'mpeg', 'mpe', 'm1v', 'm2v',
    			'mpv2', 'mp2v', 'dat', 'ts', 'tp', 'tpr', 'pva',
    			'pss', 'mp4', 'm4v', 'm4p', 'm4b', '3gp', '3gpp',
    			'3g2', '3gp2', 'mov', 'qt', 'amr', 'rm',
    			'ram', 'rmvb', 'rpm', 'mkv', 'wmv'
    		],
    };
    for (let [type, list] of Object.entries(typeConfig)) {
    	let result = list.find(v => v === suffix);
    	if (result) {
    		__type = type;
    		break;
    	}
    }
    if (_type) {
    	return __type === _type;
    }
    return __type || suffix;
}

// 解析type组件
function typeHandler(type = '') {
    const result = Object.create(null);
    result['type'] = '';
    result['many'] = false;
    if (type) {
        const index = types.findIndex(v => v.type === type);
        if (index > -1) {
            result['type'] = types[index].type;
            result['many'] = types[index].many;
        }
    }
	return result;
}

// 解析头、尾部数据
function headFootHandler(list = [], type = 'typeHeader') {
    const result = [];
    for (let i = 0, length = list.length; i < length; i++) {
        result.push({
        	data: [],
        	title: list[i].edd || list[i].ed,
        	isShow: type === 'typeFooter'   // 尾部直接显示
        });
        if (list[i].su && list[i].su.length) {
            for (let j = 0, _length = list[i].su.length; j < _length; j++) {
                let object_id = list[i].su[j].ed || '';
                let title = list[i].su[j].ed || '';
                let url = list[i].su[j].tg || '';
                if (list[i].su[j]._object_data) {
                    title = list[i].su[j]._object_data.name || '';
                    url = list[i].su[j]._object_data.url || '';
                }
                result[i].data.push({ object_id, title, url });
            }
        }
    }
    return result;
}

// 解析tg字段
function tgHandler(tg = '') {
    const result = Object.create(null);
	result['is_button'] = false;
	result['btn_text'] = '';
	result['bg_image'] = false;
    if (tg) {
        // 该obj的tg里带参数是否有action动作按钮
        let u = tg.match(/u(0|1)/);
        if (u && u[1]) {
        	result['is_button'] = !!Number(u[1]);
        	if (result['is_button']) {
        		let t = tg.match(/t(.*)/);
        		if (t && t[1]) {
        			result['btn_text'] = t[1];
        		}
        	}
        }
        // 该obj的tg里带参数是否显示背景图片
        let b = tg.match(/b(0|1)/);
        if (b && b[1]) {
        	result['bg_image'] = !!Number(b[1]);
        }
    }
	return result;
}

// 解析对象数据(切勿和tuwen数据的属性重合)
function objHandler(data = {}) {
    const result = Object.create(null);
    // 所属用户id
    result['user_id'] = data.owner_user_id || '';
    // 对象id
    result['object_id'] = data.object_id || '';
    // 可能是logo
    result['logo'] = data.photo || '';
    // 可能是标题
    result['name'] = data.name || '';
    // 图片说明
    result['alt'] = data.tag || '';
    // url跳转链接
    result['url'] = data.url || '';
    // 图片说明
    result['tag'] = data.tag || '';
    // 轮播图或商标图
    result['picture'] = [];
    // 主要图片用picture_list第一张
    result['photo'] = '';
    // 背景图片用picture_list最后一张(如果只有一张图片就不用背景图片)
    result['image'] = '';
    // 图片
    if (data.picture_list && data.picture_list.length) {
        result['picture'] = data.picture_list.map(v => v.picture);
        result['photo'] = data.picture_list[0].picture;
        if (data.picture_list.length > 1) {
            result['image'] = data.picture_list[data.picture_list.length - 1].picture;
        }
    }
    // 音频
    result['audio_url'] = fileType(data.url, 'audio') ? data.url : '';
    result['audio_url'] = fileType(data.audio_url, 'audio') ? data.audio_url : '';
    // 视频
    result['video_url'] = fileType(data.audio_url, 'video') ? data.audio_url : '';
    result['video_url'] = fileType(data.url, 'video') ? data.url : '';
    return result;
}

// 解析图文数据(切勿和object数据的属性重合)
function tuwenHandler(content = '') {
    const result = Object.create(null);
    if (content) {
        let list = content.replace(/<[a-zA-Z]>/g, '')
                          .split(/<\/[a-zA-Z]>/)
                          .map(v => v.replace(/^\s+|\s+$/g, ''))
                          .filter(v => v);
        let data = [];
        list.forEach(text => {
        	let _result = text.match(/\[(.+?)\]$/);
        	if (_result && _result[1]) {
        		// 标题
        		if (/^title:|title：/.test(text)) {
        			data.push(['title', _result[1]]);
        		}
        		// 副标题
        		if (/^subtitle:|subtitle：/.test(text)) {
        			data.push(['subtitle', _result[1]]);
        		}
        		// 内容
        		if (/^content:|content：/.test(text)) {
        			data.push(['content', _result[1]]);
        		}
        	}
        });
        if (data.length) {
            // 如果存在副标题就形成了块结构
        	let _index = data.findIndex(text => text[0] === 'subtitle');
        	if (_index > -1) {
        		let i = -1;
        		result['block'] = [];
        		data.forEach((text, index) => {
        			if (index < _index) {
        				result[text[0]] = text[1];
        			} else {
        				if (text[0] === 'subtitle') {
        					result['block'].push({
        						title: text[1]
        					});
        					i += 1;
        				} else {
        					if (result['block'][i]) {
        						result['block'][i][text[0]] = text[1];
        					} else {
        						let _obj = {};
        						_obj[text[0]] = text[0];
        						result['block'].push(_obj);
        					}
        				}
        			}
        		});
        	} else {
        		data.forEach(text => result[text[0]] = text[1]);
        	}
			// 如果存在块内容且块内容只有一条，那就取出来多增加一个副标题和内容
			if (result['block'] && result['block'].length === 1) {
				result['subtitle'] = result['block'][0].title || '';
				result['content'] = result['block'][0].content || '';
			}
        }
    }
    return result;
}

// 单条数据解析
function dataHandler(data = {}) {
    const result = Object.create(null);
    if (data && dataType(data, 'object') && data['edd']) {
        let { type, many } = typeHandler(data['edd']);
        if (type) {
            result['type'] = type;
            result['many'] = many;
            // 如果是多结构框
            if (many) {
                result['data'] = [];
                if (data['su'] && data['su'].length) {
                    for (let i = 0, length = data.su.length; i < length; i++) {
                        let _result = Object.create(null);
                        let { is_button, btn_text, bg_image } = tgHandler(data.su[i].tg);
                        // 获取对象数据
                        _result = objHandler(data.su[i]._object_data || Object.create(null));
                        _result['is_button'] = is_button;
                        _result['btn_text'] = btn_text;
                        _result['bg_image'] = bg_image;
                        // 存在图文数据解析图文
                        if (data.su[i]._tuwen_data && data.su[i]._tuwen_data.content) {
                            _result = Object.assign(_result, tuwenHandler(data.su[i]._tuwen_data.content));
                            _result.tuwen_content = data.su[i]._tuwen_data.content;
                        }
                        // 不显示背景图片则去掉
                        if (_result['bg_image'] === false) {
                        	_result['image'] = '';
                        }
                        // 将图文、对象、方程式数据添加
                        _result['_tuwen_data'] = data.su[i]._tuwen_data || Object.create(null);
                        _result['_object_data'] = data.su[i]._object_data || Object.create(null);
                        _result['_phamula_data'] = data.su[i]._phamula_data || Object.create(null);
                        result['data'].push(_result);
                    }
                }
            }
            // 如果是单结构框
            else {
                result['data'] = Object.create(null);
                if (data['su'] && data['su'].length) {
                    // 获取对象数据
                    result['data'] = objHandler(data.su[0]._object_data || Object.create(null));
                    // 头部、尾部、客服框、常见问题(获取phamula数据)
                    if (['typeHeader', 'typeFooter', 'typeTalk', 'typeO'].includes(type)) {
                        result['data'].is_button = false;
                        result['data'].btn_text = '';
                        result['data'].bg_image = false;
                        result['data'].data = [];
                        // 存在方程式数据解析方程式
                        if (data.su[0]._phamula_data && data.su[0]._phamula_data.obj_relation_json && data.su[0]._phamula_data.obj_relation_json.jsonStr) {
                            let jsonList = data.su[0]._phamula_data.obj_relation_json.jsonStr.su || [];
                            // 头尾部
                            if (['typeHeader', 'typeFooter'].indexOf(type) > -1) {
                                result['data'].data = headFootHandler(jsonList, type);
                            }
                            // 客服对话自动回答
                            if ('typeTalk' === type) {
                                result['data'].data = jsonList;
                            }
                            // 常见问题
                            if ('typeO' === type) {
                                result['data'].data = jsonList.map(questionList => {
                                    questionList['isShow'] = false;
                                    questionList['su'] = (questionList['su'] || []).map(question => {
                                    	question['isShow'] = false;
                                    	return question;
                                    });
                                    return questionList;
                                });
                            }
                        }
                    }
                    // 其它单结构框
                    else {
                        let { is_button, btn_text, bg_image } = tgHandler(data.su[0].tg);
                        result['data'].is_button = is_button;
                        result['data'].btn_text = btn_text;
                        result['data'].bg_image = bg_image;
                        // 存在图文数据解析图文
                        if (data.su[0]._tuwen_data && data.su[0]._tuwen_data.content) {
                            result['data'] = Object.assign(result['data'], tuwenHandler(data.su[0]._tuwen_data.content));
                            result['data'].tuwen_content = data.su[0]._tuwen_data.content;
                        }
                    }
                    // 不显示背景图片则去掉
                    if (result['data'].bg_image === false) {
                    	result['data'].image = '';
                    }
                    // 将图文、对象、方程式数据添加
                    result['data']._tuwen_data = data.su[0]._tuwen_data || Object.create(null);
                    result['data']._object_data = data.su[0]._object_data || Object.create(null);
                    result['data']._phamula_data = data.su[0]._phamula_data || Object.create(null);
                }
            }
            result['object_id_list'] = (many ? result['data'].map(v => v.object_id || '') : [ result['data'].object_id || '' ]).filter(Boolean);
        }
    }
    return result;
}

export default function (data = [], index = 0, carryTime = false) {
    if (data) {
        const timestamp = Date.now();
        // 如果是对象必须要提供index
        if (dataType(data, 'object')) {
            data = dataHandler(data);
            data['id'] = data['type'] + '-' + index;
            data['index'] = index;
            if (carryTime) {
                data['id'] += '-' + timestamp;
            }
            return data;
        }
        return data.map((item, i) => {
            item = dataHandler(item);
            item['id'] = item['type'] + '-' + i;
            item['index'] = i;
            if (carryTime) {
                item['id'] += '-' + timestamp;
            }
            return item;
        });
    }
    return data;
}